<script>
export default {
  mounted() {
    document.title = 'Katherine Watts Martinez Photography'
  }
}
</script>

<template>
  <div class="container">
    <h1 class="py-5">Welcome to Katherine Watts Martinez Photography</h1>
    <div class="row mb-5">
      <div class="col-12 text-center">
        <img class="mb-4" src="../assets/artwork.png" alt="">
      </div>
    </div>
    <!-- /.row -->
  </div>
</template>